import withSizes from 'react-sizes'

export const wrappedWithSizes = (...args) => WrappedComponent => {
  const ComponentWithSizes = withSizes(...args)(WrappedComponent)
  ComponentWithSizes.WrappedComponent = WrappedComponent
  return ComponentWithSizes
}
